import { Stack, Autocomplete, Box, TextField } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export const SearchAutocomplete = (props) => {
  let { heading, options } = props.val;
  let { isError } = props;
  options = options || [];
  let { state, value, onChange, multiple } = props;
  const optionLabel = (option) => {
    if (heading === "Customer") return `${option.sap_code} ${option.name}`;
    if (heading === "Resin" && option)
      return `${option.sub_class}-${option.grad}-${option.thickness}MM${
        option.dilution_percentage_recycled
          ? "-" + option.dilution_percentage_recycled + "%"
          : ""
      }`;
    return option;
  };
  const placeholderLabel = (heading, multiple, value) => {
    if (heading === "Resin") return "Select Polyolefins, PETs";
    return multiple && value.length !== 0 ? "" : "Select";
  };

  return (
    <Stack spacing={1}>
      <Box className="font-16 font-weight-600 line-height-24 black-heading">
        {heading}
      </Box>
      <Autocomplete
        multiple={multiple ? true : false}
        size="small"
        value={value}
        onChange={onChange}
        options={options}
        popupIcon={<KeyboardArrowDownIcon sx={{ color: "#3793D5" }} />}
        disablePortal
        getOptionLabel={(option) => optionLabel(option)}
        renderOption={(props, option) => (
          <Box
            component="li"
            {...props}
            key={optionLabel(option)}
            sx={{
              color: "#313131",
              fontSize: "16px",
              fontWeight: "400",
              fontFamily: "Source Sans Pro",
            }}
          >
            {optionLabel(option)}
          </Box>
        )}
        sx={{
          cursor: "pointer",
          "& .MuiAutocomplete-inputRoot": {
            height: 40,
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label=""
            className="filterInput"
            placeholder={placeholderLabel(heading, multiple, value)}
            error={isError}
          />
        )}
        error={isError}
      />
    </Stack>
  );
};
